export default __webpack_public_path__ + "static/media/shiftRotation.0a0547b6.svg";